export default __webpack_public_path__ + "static/media/SPORT 100 KLS_5.a95a52e5.webp";